const getCardBrand = (cardNumber) => {
  if (RegExp("^4,*").test(cardNumber)) {
    return "VISA";
  }
  if (RegExp("^5(1|2|3|4|5),*").test(cardNumber) || RegExp("^2,*").test(cardNumber)) {
    return "MASTERCARD";
  }
  if (RegExp("^3(4|7),*").test(cardNumber)) {
    return "AMEX";
  }
  if (RegExp("^5(0|6|7|8),*").test(cardNumber) || RegExp("^6,*").test(cardNumber)) {
    return "MAESTRO";
  }
  return "OTHER";
};
const getCardType = (cardBrand) => ["VISA", "MASTERCARD", "CB"].includes(cardBrand) ? "CB_VISA_MASTERCARD" : cardBrand;
const getCardNumberMaxLengthByBrand = (cardBrand) => {
  switch (cardBrand) {
    case "VISA":
    case "MAESTRO":
      return 23;
    case "AMEX":
      return 18;
    default:
      return 19;
  }
};
const formatCardNumber = (cardNumber) => {
  var _a;
  const cardBrand = getCardBrand(cardNumber);
  const maxLength = getCardNumberMaxLengthByBrand(cardBrand);
  let formattedCardNumber = ((_a = cardNumber.replace(/\s/g, "").replace(
    /\D/g,
    ""
    // To allow only digits
  ).match(/.{1,4}/g)) == null ? void 0 : _a.join(" ")) ?? "";
  formattedCardNumber = formattedCardNumber.substr(0, maxLength);
  return formattedCardNumber;
};
const formatCardExpiry = (cardExpiry) => {
  const formattedCardExpiry = cardExpiry.replace(
    /^([1-9]\/|[2-9])$/g,
    "0$1/"
    // 3 > 03/
  ).replace(
    /^(0[1-9]|1[0-2])$/g,
    "$1/"
    // 11 > 11/
  ).replace(
    /^([0-1])([3-9])$/g,
    "0$1/$2"
    // 13 > 01/3
  ).replace(
    /^(0?[1-9]|1[0-2])([0-9]{2})$/g,
    "0$1/$2"
    // 141 > 01/41
  ).replace(
    /^0{1,5}\/$/g,
    "0"
    // 0/ > 0
  ).replace(
    /^0{1,5}$/g,
    "0"
    // 00 > 0
  ).replace(
    /[^\d\/]/g,
    ""
    // Remove non-digits and non-slash characters
  ).replace(
    /^[\/]{0,5}$/g,
    ""
    // Remove strings that are only slashes
  ).replace(
    /\/\//g,
    "/"
    // Prevent entering more than 1 `/`
  ).substring(0, 5);
  return formattedCardExpiry;
};
const formatCardCvc = (cardCvc) => {
  const formattedCardCvc = cardCvc.replace(/\D/g, "").substring(0, 4);
  return formattedCardCvc;
};
const validateCardNumber = (cardNumber) => {
  if (/[^0-9-\s]+/.test(cardNumber) || cardNumber === "") {
    return false;
  }
  const value = cardNumber.replace(/\D/g, "");
  let sum = 0;
  let isEvenDigit = false;
  for (let i = value.length - 1; i >= 0; i--) {
    const digitChar = value.charAt(i);
    let digit = parseInt(digitChar, 10);
    if (isEvenDigit && (digit *= 2) > 9) {
      digit -= 9;
    }
    sum += digit;
    isEvenDigit = !isEvenDigit;
  }
  const isValid = sum % 10 === 0;
  return isValid;
};
const validateIsCardExpired = (cardExpiry) => {
  const [month, year] = cardExpiry.split("/");
  const today = /* @__PURE__ */ new Date();
  const expiryYear = parseInt(`20${year}`, 10);
  const expiryMonth = parseInt(month, 10);
  if (expiryYear > today.getFullYear()) {
    return true;
  }
  if (expiryYear === today.getFullYear() && expiryMonth >= today.getMonth() + 1) {
    return true;
  }
  return false;
};
const validateCardExpiry = (cardExpiry) => {
  if (cardExpiry.length < 5) {
    return false;
  }
  if (!/^(0[1-9]|1[0-2])\/([0-9]{2})$/.test(cardExpiry)) {
    return false;
  }
  return validateIsCardExpired(cardExpiry);
};
const parseCardExpiry = (expiry) => {
  const [monthPart, yearPart] = expiry.split("/") ?? [];
  const month = +monthPart.trim();
  const year = +yearPart.trim() + 2e3;
  return {
    month,
    year
  };
};
const parseCardNumber = (cardNumber) => {
  const result = cardNumber.replace(/\D/g, "");
  return result;
};
const convertCardExpiryToString = (expDate) => {
  const paddedExpDate = expDate.padStart(4, "0");
  const month = paddedExpDate.slice(0, 2);
  const year = paddedExpDate.slice(2);
  return `${month}/${year}`;
};
const getCardNumberEnding = (cardNumber) => {
  const parts = cardNumber.trim().split(" ");
  const ending = parts[parts.length - 1];
  return ending;
};
const maskCardNumber = (cardNumber, maskChar = "*") => {
  const parts = cardNumber.trim().split(" ");
  const maskedParts = parts.map((part, index) => index === parts.length - 1 ? part : part.replace(/\d/g, maskChar));
  const maskedCardNumber = maskedParts.join(" ");
  return maskedCardNumber;
};
const getCardCvcLengthRangeByBrand = (cardBrand) => {
  switch (cardBrand) {
    case "VISA":
    case "MASTERCARD":
    case "MAESTRO":
      return {
        min: 3,
        max: 3
      };
    case "AMEX":
      return {
        min: 3,
        max: 4
      };
    default:
      return {
        min: 3,
        max: 4
      };
  }
};
const getCardBrandsFromCardType = (cardType) => {
  switch (cardType) {
    case "CB_VISA_MASTERCARD":
      return ["CB", "VISA", "MASTERCARD"];
    case "AMEX":
      return ["AMEX"];
    case "MAESTRO":
      return ["MAESTRO"];
    default:
      return ["OTHER"];
  }
};
const formatCardBillingName = (value) => {
  const trimmedValue = value.trim();
  return trimmedValue.length > 45 ? trimmedValue.slice(0, 45) : value;
};
const composeValidators = (validator1, validator2, validator3, validator4, validator5) => {
  const validators = [validator1, validator2, validator3, validator4, validator5].filter(
    (validator) => !!validator
  );
  const composedValidator = (value) => validators.reduce(
    (result, validator) => ({ ...result, ...validator(value) }),
    {}
  );
  return composedValidator;
};
const maxLengthValidatorKey = "maxLength";
const maxLengthValidator = (maxLength) => {
  return (value) => {
    const isValid = value !== null && value !== void 0 && value.length <= maxLength;
    return {
      [maxLengthValidatorKey]: isValid
    };
  };
};
const minLengthValidatorKey = "minLength";
const minLengthValidator = (minLength) => {
  return (value) => {
    const isValid = !!value && value.length >= minLength;
    return {
      [minLengthValidatorKey]: isValid
    };
  };
};
const patternValidatorKey = "pattern";
const patternValidator = (pattern) => {
  return (value) => {
    const isValid = pattern.test(value);
    return {
      [patternValidatorKey]: isValid
    };
  };
};
const requiredValidatorKey = "required";
const requiredValidator = (value) => {
  const isValid = !!value && value.length > 0;
  return {
    [requiredValidatorKey]: isValid
  };
};
const cardExpiryValidatorKey = "cardExpiry";
const cardExpiryValidator = (value) => ({
  [cardExpiryValidatorKey]: validateCardExpiry(value)
});
const cardNumberValidatorKey = "cardNumber";
const cardNumberValidator = (value) => ({
  [cardNumberValidatorKey]: validateCardNumber(value)
});
const cardExpiryPatternValidator = patternValidator(/^(0[1-9]|1[0-2])\/([0-9]{2})$/);
const customCardExpiryPatternValidator = (pattern) => patternValidator(pattern);
const noopValidator = () => ({});
const cardCvcLengthValidator = (cardBrand) => {
  const cvcLengthRange = getCardCvcLengthRangeByBrand(cardBrand);
  const cvcMinLengthValidator = minLengthValidator(cvcLengthRange.min ?? Number.MIN_SAFE_INTEGER);
  const cvcMaxLengthValidator = maxLengthValidator(cvcLengthRange.max ?? Number.MAX_SAFE_INTEGER);
  return (value) => {
    return {
      ...cvcMinLengthValidator(value),
      ...cvcMaxLengthValidator(value)
    };
  };
};
const stackValidators = (validator1, validator2, validator3, validator4, validator5) => {
  const validators = [validator1, validator2, validator3, validator4, validator5].filter(
    (validator) => !!validator
  );
  const stackedValidator = (value) => {
    let result = void 0;
    for (const validator of validators) {
      const validationResult = validator(value);
      const keys = Object.keys(validationResult);
      const [key] = keys.filter((param) => !validationResult[param]);
      if (key && !validationResult[key]) {
        result = validationResult;
        break;
      }
    }
    return result;
  };
  return stackedValidator;
};
const mergeConfigs = (defaultConfig, configOverrides) => {
  if (!configOverrides || Object.keys(configOverrides).length === 0) {
    return defaultConfig;
  }
  const mergedConfig = Object.entries(defaultConfig).reduce((result, [key, defaultValue]) => {
    if (typeof defaultValue === "object") {
      result[key] = mergeConfigs(defaultValue, configOverrides == null ? void 0 : configOverrides[key]);
    } else {
      result[key] = (configOverrides == null ? void 0 : configOverrides[key]) ?? defaultValue;
    }
    return result;
  }, {});
  return mergedConfig;
};
class CustomTypedError extends Error {
  constructor(error) {
    super(JSON.stringify(error));
    this.Status = error.Status;
    this.ResultCode = error.ResultCode;
    this.ResultMessage = error.ResultMessage;
  }
}
const generateUuid = () => {
  const result = "10000000-1000-4000-8000-100000000000".replace(
    /[018]/g,
    (c) => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
  return result;
};
var AuthorizeErrorCode = /* @__PURE__ */ ((AuthorizeErrorCode2) => {
  AuthorizeErrorCode2["Apm"] = "error.authorize.requiresApmAuthorization";
  AuthorizeErrorCode2["ThreeDs"] = "error.authorize.requires3DSecure";
  return AuthorizeErrorCode2;
})(AuthorizeErrorCode || {});
const handledAuthorizeErrorCodes = [AuthorizeErrorCode.Apm, AuthorizeErrorCode.ThreeDs];
const checkHasAuthorizeErrorToHandle = (errors) => {
  var _a, _b;
  const errorObject = errors == null ? void 0 : errors.find(
    (error) => {
      var _a2, _b2;
      return ((_a2 = error.extensions) == null ? void 0 : _a2.code) && handledAuthorizeErrorCodes.includes((_b2 = error.extensions) == null ? void 0 : _b2.code);
    }
  );
  return {
    hasAuthorizeErrorToHandle: Boolean(errorObject),
    authUrl: (_a = errorObject == null ? void 0 : errorObject.extensions) == null ? void 0 : _a.url,
    supportsIframe: Boolean((_b = errorObject == null ? void 0 : errorObject.extensions) == null ? void 0 : _b.supportsIframe)
  };
};
const isPopUpWindow = () => {
  try {
    return !!window.opener;
  } catch {
    return false;
  }
};
const MISSING_PARAMS_ERROR = {
  Status: "ERROR",
  ResultCode: "130005",
  ResultMessage: `One or several required parameters are missing or incorrect. An incorrect resource ID also raises
  this kind of error.`
};
const TOKEN_PROCESSING_ERROR = {
  Status: "ERROR",
  ResultCode: "001599",
  ResultMessage: "Token processing error"
};
const getCenteredPopupFeatures = (width, height) => {
  const left = window.outerWidth / 2 + window.screenX - width / 2;
  const top = window.outerHeight / 2 + window.screenY - height / 2;
  return `resizable=yes,width=${+width},height=${+height},top=${+top},left=${+left}`;
};
const createScriptElement = ({
  src,
  id,
  onScriptLoad,
  onScriptError,
  crossOrigin
}) => {
  const script = document.createElement("script");
  script.src = src;
  if (id) {
    script.id = id;
  }
  if (crossOrigin) {
    script.crossOrigin = crossOrigin;
  }
  script.async = true;
  script.defer = true;
  if (onScriptLoad) {
    script.addEventListener("load", onScriptLoad);
  }
  if (onScriptError) {
    script.addEventListener("error", onScriptError);
  }
  document.body.appendChild(script);
  const removeElementFn = () => {
    if (onScriptLoad) {
      script.removeEventListener("load", onScriptLoad);
    }
    if (onScriptError) {
      script.removeEventListener("error", onScriptError);
    }
    document.body.removeChild(script);
  };
  return {
    element: script,
    removeElementFn
  };
};
const trimSpaces = (value) => value.replace(/\s/g, "");
const capitalize = (s) => s && String(s[0]).toUpperCase() + String(s).slice(1).toLowerCase();
const getCurrencyFormat = (amountInCents, currency) => {
  const amount = Number(amountInCents) / 100;
  const parts = amount.toFixed(2).split(".");
  const integerPart = Number(parts[0]).toLocaleString("en-US", { maximumFractionDigits: 0 });
  const decimalPart = parts[1];
  switch (currency.toUpperCase()) {
    case "EUR":
      return `€${integerPart}.${decimalPart}`;
    case "USD":
      return `$${integerPart}.${decimalPart}`;
    case "GBP":
      return `£${integerPart}.${decimalPart}`;
    case "SEK":
      return `kr${integerPart}.${decimalPart}`;
    case "CHF":
      return `CHF ${integerPart}.${decimalPart}`;
    case "CAD":
      return `$${integerPart}.${decimalPart} CAD`;
    case "DKK":
      return `kr${integerPart},${decimalPart}`;
    case "AUD":
      return `$${integerPart}.${decimalPart} AUD`;
    case "NOK":
      return `kr${integerPart},${decimalPart}`;
    case "PLN":
      return `${integerPart},${decimalPart} zł`;
    case "ZAR":
      return `R${integerPart}.${decimalPart}`;
    default:
      return `${currency}${integerPart}.${decimalPart}`;
  }
};
const validCardDataWithout3ds = {
  cardNumber: "4970107111111119",
  billingName: "John Doe",
  cardExpiry: "12/30",
  cardCvc: "123"
};
const validCardDataWith3ds = {
  cardNumber: "4970105181818183",
  billingName: "John Doe",
  cardExpiry: "12/33",
  cardCvc: "321"
};
const validCardDataWithCb = {
  cardNumber: "5130230007895712",
  billingName: "John Doe",
  cardExpiry: "12/30",
  cardCvc: "123"
};
const invalidCardData = {
  cardNumber: "4000000000000341",
  billingName: "John Doe",
  cardExpiry: "12/30",
  cardCvc: "123"
};
const validationTestCases = [
  {
    name: "Card number is required",
    data: { ...validCardDataWithout3ds, cardNumber: "" },
    expectedError: "Card number is required"
  },
  {
    name: "Minimum number of digits is 13",
    data: { ...validCardDataWithout3ds, cardNumber: "123" },
    expectedError: "Minimum number of digits is 13"
  },
  {
    name: "Full name is required",
    data: { ...validCardDataWithout3ds, billingName: "" },
    expectedError: "Full name is required"
  },
  {
    name: "Expiration date is required",
    data: { ...validCardDataWithout3ds, cardExpiry: "" },
    expectedError: "Expiration date is required"
  },
  {
    name: "Expiration date format is not valid (MM/YY)",
    data: { ...validCardDataWithout3ds, cardExpiry: "1325" },
    expectedError: "Expiration date format is not valid (MM/YY)"
  },
  {
    name: "Your card is expired",
    data: { ...validCardDataWithout3ds, cardExpiry: "01/20" },
    expectedError: "Your card is expired"
  },
  {
    name: "Security code is required",
    data: { ...validCardDataWithout3ds, cardCvc: "" },
    expectedError: "Security code is required"
  },
  {
    name: "Security code is too short",
    data: { ...validCardDataWithout3ds, cardCvc: "1" },
    expectedError: "Security code is too short"
  },
  {
    name: "Security code is too long",
    data: { ...validCardDataWithout3ds, cardCvc: "12345" },
    expectedError: "Security code is too long"
  }
];
const binLookUpExpectedResponse = {
  BinData: [
    {
      Brand: "CB",
      CardType: "DEBIT",
      CommercialIndicator: "PERSONAL",
      SubType: "STANDARD"
    },
    {
      Brand: "MASTERCARD",
      SubType: "STANDARD",
      CardType: "DEBIT",
      CommercialIndicator: "PERSONAL"
    }
  ]
};
async function findAndSelectComponent(page, component, subtype) {
  const inputSelector = 'input[placeholder="Find components"]';
  await page.waitForSelector(inputSelector);
  await page.fill(inputSelector, component);
  const liSelector = `[data-id="${component.toLowerCase()}"]`;
  await page.waitForSelector(liSelector);
  await page.click(liSelector);
  const linkId = `${component.toLowerCase()}--${subtype}`;
  const linkSelector = `#${linkId}`;
  await page.waitForSelector(linkSelector);
  await page.click(linkSelector);
  const fullscreenButton = await page.waitForSelector('button[aria-label="Go full screen"]');
  await fullscreenButton.click();
  const storybookIframe = await page.waitForSelector("#storybook-preview-iframe");
  const storybookFrame = await storybookIframe.contentFrame();
  if (!storybookFrame) {
    throw new Error("Failed to get the content frame of the storybook iframe.");
  }
  await storybookFrame.waitForLoadState("load");
  return { storybookFrame };
}
async function locateSDKFrame(storybookFrame) {
  const sdkIframe = await storybookFrame.waitForSelector("iframe");
  const sdkFrame = await sdkIframe.contentFrame();
  if (!sdkFrame) {
    throw new Error("Failed to get the content frame of the SDK iframe.");
  }
  await sdkFrame.waitForLoadState("load");
  return sdkFrame;
}
async function findAndSelectSDK(page, component, subtype) {
  const { storybookFrame } = await findAndSelectComponent(page, component, subtype);
  const sdkFrame = await locateSDKFrame(storybookFrame);
  return { sdkFrame, storybookFrame };
}
async function fillForm(context, { cardNumber, billingName, cardExpiry, cardCvc }) {
  const isPage = "context" in context;
  const cardCvcSelector = isPage ? "#cardCvx" : "#cardCvc";
  await context.fill("#cardNumber", cardNumber);
  await context.fill("#billingName", billingName);
  await context.fill("#cardExpiry", cardExpiry);
  await context.fill(cardCvcSelector, cardCvc);
}
async function submitPaymentForm(context, customButtonSelector) {
  let payButton;
  if (customButtonSelector) {
    payButton = await context.waitForSelector(customButtonSelector, { state: "visible" });
  } else {
    payButton = await context.waitForSelector("#pay", { state: "visible" });
  }
  await payButton.click();
}
async function handle3dsFlow(storybookFrame) {
  await storybookFrame.waitForSelector('h3:has-text("3D Secure authentication")');
  const secureIframe = await storybookFrame.waitForSelector('h3:has-text("3D Secure authentication") + iframe', {
    timeout: 1e4
  });
  const secureFrame = await secureIframe.contentFrame();
  if (!secureFrame) {
    throw new Error("Failed to get the content frame of the 3ds iframe.");
  }
  await secureFrame.waitForLoadState("load", { timeout: 3e4 });
  await secureFrame.waitForSelector('h1:has-text("3D Secure Test Page")', { timeout: 1e4 });
  const confirmButton = await secureFrame.waitForSelector(".popup-btn-success", {
    state: "visible",
    timeout: 3e4
  });
  await confirmButton.click();
}
async function waitForPaymentCompletion(storybookFrame) {
  await storybookFrame.waitForSelector("text=Payment completed");
}
async function clearField(context, selector) {
  const input = context.locator(selector);
  await input.click();
  await input.fill("");
  await input.blur();
}
var CheckoutSdkEnvironment = /* @__PURE__ */ ((CheckoutSdkEnvironment2) => {
  CheckoutSdkEnvironment2["SANDBOX"] = "SANDBOX";
  CheckoutSdkEnvironment2["PRODUCTION"] = "PRODUCTION";
  return CheckoutSdkEnvironment2;
})(CheckoutSdkEnvironment || {});
var CheckoutSdkHostEventType = /* @__PURE__ */ ((CheckoutSdkHostEventType2) => {
  CheckoutSdkHostEventType2["Initialize"] = "initialize";
  CheckoutSdkHostEventType2["Disable"] = "disable";
  CheckoutSdkHostEventType2["Enable"] = "enable";
  CheckoutSdkHostEventType2["ClickOutside"] = "clickOutside";
  CheckoutSdkHostEventType2["HostAuthComplete"] = "hostAuthComplete";
  CheckoutSdkHostEventType2["SetErrorMessage"] = "setErrorMessage";
  CheckoutSdkHostEventType2["CompletePayment"] = "completePayment";
  CheckoutSdkHostEventType2["PaymentComplete"] = "paymentComplete";
  CheckoutSdkHostEventType2["TokenizationComplete"] = "tokenizationComplete";
  CheckoutSdkHostEventType2["AuthorizeApplePayComplete"] = "authorizeApplePayComplete";
  CheckoutSdkHostEventType2["GetGooglePayToken"] = "getGooglePayToken";
  CheckoutSdkHostEventType2["SetLoading"] = "setLoading";
  CheckoutSdkHostEventType2["CreateCardRegistrationComplete"] = "createCardRegistrationComplete";
  CheckoutSdkHostEventType2["CreatePaypalPaymentComplete"] = "createPaypalPaymentComplete";
  CheckoutSdkHostEventType2["CreateCardPaymentComplete"] = "createCardPaymentComplete";
  CheckoutSdkHostEventType2["CreateGooglePayPaymentComplete"] = "createGooglePayPaymentComplete";
  CheckoutSdkHostEventType2["CreateApplePayPaymentComplete"] = "createApplePayPaymentComplete";
  CheckoutSdkHostEventType2["LogHostEvent"] = "logHostEvent";
  CheckoutSdkHostEventType2["LogHostError"] = "logHostError";
  CheckoutSdkHostEventType2["LogCancelPayment"] = "logCancelPayment";
  CheckoutSdkHostEventType2["DeactivateSavedCardComplete"] = "deactivateSavedCardComplete";
  return CheckoutSdkHostEventType2;
})(CheckoutSdkHostEventType || {});
var CheckoutSdkFrameEventType = /* @__PURE__ */ ((CheckoutSdkFrameEventType2) => {
  CheckoutSdkFrameEventType2["Initialize"] = "initialize";
  CheckoutSdkFrameEventType2["Change"] = "change";
  CheckoutSdkFrameEventType2["Cancel"] = "cancel";
  CheckoutSdkFrameEventType2["Error"] = "error";
  CheckoutSdkFrameEventType2["Resize"] = "resize";
  CheckoutSdkFrameEventType2["OpenHostAuthPopupWindow"] = "openHostAuthPopupWindow";
  CheckoutSdkFrameEventType2["CloseHostAuthPopupWindow"] = "closeHostAuthPopupWindow";
  CheckoutSdkFrameEventType2["OpenHostAuthPopupModal"] = "openHostAuthPopupModal";
  CheckoutSdkFrameEventType2["CloseHostAuthPopupModal"] = "closeHostAuthPopupModal";
  CheckoutSdkFrameEventType2["SetErrorMessage"] = "setErrorMessage";
  CheckoutSdkFrameEventType2["PaymentMethodSelect"] = "paymentMethodSelect";
  CheckoutSdkFrameEventType2["PaymentComplete"] = "paymentComplete";
  CheckoutSdkFrameEventType2["TokenizationComplete"] = "tokenizationComplete";
  CheckoutSdkFrameEventType2["GetGooglePayToken"] = "getGooglePayToken";
  CheckoutSdkFrameEventType2["CreateCardRegistration"] = "createCardRegistration";
  CheckoutSdkFrameEventType2["DeactivateSavedCard"] = "deactivateSavedCard";
  CheckoutSdkFrameEventType2["CreatePaypalPayment"] = "createPaypalPayment";
  CheckoutSdkFrameEventType2["ShowPopupWindowOverlay"] = "showPopupWindowOverlay";
  CheckoutSdkFrameEventType2["CreateCardPayment"] = "createCardPayment";
  CheckoutSdkFrameEventType2["CreateGooglePayPayment"] = "createGooglePayPayment";
  CheckoutSdkFrameEventType2["CreateApplePayPaymentRequest"] = "createApplePayPaymentRequest";
  CheckoutSdkFrameEventType2["CreateApplePayPayIn"] = "createApplePayPayIn";
  return CheckoutSdkFrameEventType2;
})(CheckoutSdkFrameEventType || {});
var CheckoutSdkFrameParam = /* @__PURE__ */ ((CheckoutSdkFrameParam2) => {
  CheckoutSdkFrameParam2["Referrer"] = "referrer";
  CheckoutSdkFrameParam2["Version"] = "version";
  CheckoutSdkFrameParam2["SdkType"] = "sdkType";
  return CheckoutSdkFrameParam2;
})(CheckoutSdkFrameParam || {});
class BaseSdkEventsDispatcher {
  listen(host, targetOrigin) {
    this.targetOrigin = targetOrigin;
    const listener = (event) => this.onMessage(event);
    host.addEventListener("message", listener);
    return () => host.removeEventListener("message", listener);
  }
  dispatchMessage(eventType, data) {
    if (!this.target) {
      throw new Error("Proxy target is required.");
    }
    const message = { eventType, data };
    try {
      this.target.postMessage(message, { targetOrigin: this.targetOrigin });
    } catch (e) {
      console.error(
        `Something went wrong. Please check the provided options. This error most likely happens when you try to pass a function that is not allowed.`
      );
      throw e;
    }
  }
  onMessage(event) {
    if (event.origin !== this.targetOrigin) {
      return;
    }
    if (!this.target) {
      this.target = event.source ?? void 0;
    }
    this.onIncomingMessage(event.data);
  }
}
var CheckoutSdkFrameParamKey = /* @__PURE__ */ ((CheckoutSdkFrameParamKey2) => {
  CheckoutSdkFrameParamKey2["Referrer"] = "wt-referrer";
  CheckoutSdkFrameParamKey2["Version"] = "wt-version";
  return CheckoutSdkFrameParamKey2;
})(CheckoutSdkFrameParamKey || {});
const NETHONE_PROFILER_SCRIPT_ID = "nethone-profiler-script";
const LOAD_NETHONE_PROFILER_SCRIPT_ERROR_MESSAGE = "Failed to load Nethone Profiler script";
var GooglePayCardAuthMethod = /* @__PURE__ */ ((GooglePayCardAuthMethod2) => {
  GooglePayCardAuthMethod2["PAN_ONLY"] = "PAN_ONLY";
  GooglePayCardAuthMethod2["CRYPTOGRAM_3DS"] = "CRYPTOGRAM_3DS";
  return GooglePayCardAuthMethod2;
})(GooglePayCardAuthMethod || {});
const WebCardPayInResult = {};
export {
  AuthorizeErrorCode,
  BaseSdkEventsDispatcher,
  CheckoutSdkEnvironment,
  CheckoutSdkFrameEventType,
  CheckoutSdkFrameParam,
  CheckoutSdkFrameParamKey,
  CheckoutSdkHostEventType,
  CustomTypedError,
  GooglePayCardAuthMethod,
  LOAD_NETHONE_PROFILER_SCRIPT_ERROR_MESSAGE,
  MISSING_PARAMS_ERROR,
  NETHONE_PROFILER_SCRIPT_ID,
  TOKEN_PROCESSING_ERROR,
  WebCardPayInResult,
  binLookUpExpectedResponse,
  capitalize,
  cardCvcLengthValidator,
  cardExpiryPatternValidator,
  cardExpiryValidator,
  cardExpiryValidatorKey,
  cardNumberValidator,
  cardNumberValidatorKey,
  checkHasAuthorizeErrorToHandle,
  clearField,
  composeValidators,
  convertCardExpiryToString,
  createScriptElement,
  customCardExpiryPatternValidator,
  fillForm,
  findAndSelectComponent,
  findAndSelectSDK,
  formatCardBillingName,
  formatCardCvc,
  formatCardExpiry,
  formatCardNumber,
  generateUuid,
  getCardBrand,
  getCardBrandsFromCardType,
  getCardCvcLengthRangeByBrand,
  getCardNumberEnding,
  getCardType,
  getCenteredPopupFeatures,
  getCurrencyFormat,
  handle3dsFlow,
  invalidCardData,
  isPopUpWindow,
  maskCardNumber,
  maxLengthValidator,
  maxLengthValidatorKey,
  mergeConfigs,
  minLengthValidator,
  minLengthValidatorKey,
  noopValidator,
  parseCardExpiry,
  parseCardNumber,
  patternValidator,
  patternValidatorKey,
  requiredValidator,
  requiredValidatorKey,
  stackValidators,
  submitPaymentForm,
  trimSpaces,
  validCardDataWith3ds,
  validCardDataWithCb,
  validCardDataWithout3ds,
  validateCardExpiry,
  validateCardNumber,
  validationTestCases,
  waitForPaymentCompletion
};
//# sourceMappingURL=index.js.map
